import { CommonModule } from '@angular/common';
import { Component, WritableSignal, signal } from '@angular/core';
import { BaseWidget } from '@app/widgets/base-widget/base-widget';

@Component({
  selector: 'app-jwt-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './jwt-login.component.html',
})
export class JwtLoginComponent extends BaseWidget {

  readonly isJwtFlowEnabled: WritableSignal<boolean> = signal(false);
  readonly buttonLabel: WritableSignal<string> = signal('Switch to JWT Login');

  ngOnInit(): void {
    this.syncFromCookie();
  }

  toggleLoginMode(): void {
    if (this.isJwtFlowEnabled()) {
      this.cookieService.clearCookie('jwt_flow');
    } else {
      this.cookieService.setCookie('jwt_flow', 'true');
    }

    this.syncFromCookie();
  }

  private syncFromCookie(): void {
    const enabled: boolean = this.cookieService.getCookie('jwt_flow') === 'true';
    this.isJwtFlowEnabled.set(enabled);
    this.buttonLabel.set(
      enabled ? 'Switch to Session Login' : 'Switch to JWT Login',
    );
  }
}
